<template>
  <v-autocomplete
    ref="autocomplete"
    :label="label"
    :items="items"
    @change="changeItem"
    @click:append="$emit('clickappend')"
    v-bind="$attrs"
  ></v-autocomplete>
</template>

<script>
export default {
  name: 'Autocomplete',
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    resetAfterChange: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeItem(item) {
      this.$emit('change', item);
      if (this.resetAfterChange) this.$refs.autocomplete.reset();
    }
  }
}
</script>